<template>
	<v-container>
		<Snackbar v-if="errored" msg="Error from Server" />
		<Snackbar v-if="deleted" msg="Operation Successfull" />		
		<v-dialog v-model="create" width="75%">
			<v-card>
				<NewPublication ref="createDialog"/>
			</v-card>
		</v-dialog>
		<v-dialog v-model="edit" width="75%">
			<v-card>
				<EditPublication :editId="editId" ref="editDialog"/>
			</v-card>
		</v-dialog>	
		<v-card-title>
			Publications
			<v-spacer></v-spacer>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			></v-text-field>
			<v-btn
				color="success"
				class="ml-8"
				@click="create = !create"
			>
				New
				<v-icon class="ms-2">
					mdi-plus
				</v-icon>
			</v-btn>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="publications"
			:search="search"
			class="elevation-1"
		>
			<template v-slot:[`item.actions`]="{ item }">
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="primary"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="(editId = item._id) && (edit = !edit)"
						>
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span> Edit </span>
				</v-tooltip>                
				<v-tooltip right>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="error"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="confirmDelete() && deletePublication(item)"
						>
							<v-icon>mdi-delete</v-icon>
						</v-btn>
					</template>
					<span> Delete </span>
				</v-tooltip>
			</template>			
		</v-data-table>
	</v-container>
</template>

<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
import NewPublication from '../Publications/New.vue'
import EditPublication from '../Publications/Edit.vue'

export default {
  name: 'Publications',
	components: {
		Snackbar,
		NewPublication,
		EditPublication
	},	
  data: () => ({
    loading: true,
    errored: false,
    deleted: false,
		create: false,
		edit: false,
		editId: null,		
    publications: [],
		search: '',
		headers: [
			{ text: 'Title', value: 'title', width: '20%', align: 'start' },
			{ text: 'Year', value: 'year', width: '10%', align: 'start' },
			{ text: 'Author', value: 'author', width: '20%', align: 'start' },
			{ text: 'Categories', value: 'category', width: '15%', align: 'start' },
			{ text: 'Projects', value: 'projectId', width: '25%', align: 'start' },
			{ text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '10%' }
		]
  }),
	mounted() {
		this.getPublications();
	},
	methods: {
		formateCategories(category){
			let allCategories = '';
			for(var i=0; i<category.length; i++){
				allCategories += category[i].name;
				if(category[i+1]){
					allCategories += ", ";
				}
			}
			return allCategories;
		},

		formateProjects(projects){
			let allProjects = '';
			for(var i=0; i<projects.length; i++){
				allProjects += projects[i].name;
				if(projects[i+1]){
					allProjects += ", ";
				}
			}
			return allProjects;
		},

		formatePublications(){
			this.publications.forEach(e => {
				e.category = this.formateCategories(e.category);
				e.projectId = this.formateProjects(e.projectId);
			});
			return;
		},

		getPublications(){
			axios
			.get(`/publication/dashboard/`)
			.then(res => {
				this.publications = res.data.data;
				this.formatePublications();
			})
			.catch(err => {
				console.error("axios err", err);
				this.errored = true;
			})
			.finally(() => this.loading = false);
		},

		confirmDelete(){
			return confirm("Are you sure you want to delete this publication?");
		},

		deletePublication(publication){
			axios
			.delete(`/publication/`, {data: {_id: publication._id}})
			.then(() => {
        this.deleted = true
				this.getPublications();
			})
			.catch(err => {
				console.error("error", err);
				this.errored = true;
			})
			.finally(() => {
				this.loading = false;
			});
		}
	},
	watch: {
		create: function(){
			if(!this.create){
				this.getPublications();
				this.$refs.createDialog.reset();
			}
		},

		edit: function(){
			if(!this.edit){
				this.getPublications();
				this.editId = null;
				this.$refs.editDialog.reset();
			}
		}
	}
}	
</script>

<style>

</style>